import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "The website completely transformed how customers see my business. It looks like a million-dollar brand — and the leads started coming in within a week.",
    name: "Marcus Bell",
    role: "Founder, Bell Auto Detailing",
  },
  {
    quote:
      "Fast, professional and stunning. I gave a rough idea and got back something far beyond what I imagined. Booking enquiries doubled.",
    name: "Sofia Ramos",
    role: "Owner, Ramos Studio",
  },
  {
    quote:
      "Every detail felt intentional and premium. My clients constantly compliment the site. Worth every penny.",
    name: "Daniel Okafor",
    role: "Director, Okafor Consulting",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="mb-16 max-w-2xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 bg-[#d4af37]" />
            <span className="text-xs uppercase tracking-[0.3em] gold-text">Kind Words</span>
          </div>
          <h2 className="font-serif-display font-light text-4xl md:text-6xl tracking-tight">
            Trusted by <span className="italic gold-text">growing brands</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="glass-card rounded-3xl p-8 md:p-10 flex flex-col"
            >
              <Quote size={36} className="text-[#d4af37]/40 mb-6" />
              <blockquote className="text-white/75 leading-relaxed text-lg flex-1 font-serif-display italic">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10">
                <p className="text-white font-medium">{t.name}</p>
                <p className="text-white/40 text-sm tracking-wide">{t.role}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
